export default "__VITE_ASSET__Bxqg1Fkj__"